<template>
    <div class="login-page">
        <div class="wrapper wrapper-full-page">
            <div class="full-page login-page section-image">
                <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
                <div class="content">
                    <div class="container">
                        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                            <card type="login">
                                <form @submit.prevent="submitLogin">
                                    <h3 slot="header" class="header text-center mb-2">
                                        Login
                                    </h3>
                                    <p v-if="error" class="text-danger mb-2 mt-0">
                                        {{ error }}
                                    </p>
                                    <fg-input
                                        v-model="form.email"
                                        v-validate="modelValidations.email"
                                        :error="getError('email')"
                                        data-vv-validate-on="blur"
                                        name="email"
                                        placeholder="Email"
                                        type="email"
                                    >
                                        <template slot="addonLeft">
                                            <span class="span-addon-left"><i class="nc-icon nc-single-02"></i></span>
                                        </template>
                                    </fg-input>

                                    <fg-input
                                        v-model="form.password"
                                        v-validate="modelValidations.password"
                                        :error="getError('password')"
                                        data-vv-validate-on="blur"
                                        name="password"
                                        placeholder="Password"
                                        type="password"
                                    >
                                        <template slot="addonLeft">
                                            <span class="span-addon-left"><i class="nc-icon nc-key-25"></i></span>
                                        </template>
                                    </fg-input>

                                    <p-checkbox v-model="form.rememberMe">
                                        Remember Me
                                    </p-checkbox>

                                    <p-button slot="footer" :disabled="loading" nativeType="submit" type="primary" block class="btn-round mb-3">
                                        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                                        {{ loading ? null : 'Login' }}
                                    </p-button>
                                    <router-link :to="{ path: '/forgot-password' }">Forgot your password?</router-link>
                                </form>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MIN_PASSWORD_LENGTH } from '@/utils/constants'
import { getError } from '@/utils/validateErrors'
import { Card, Checkbox, Button } from '@/components/UIComponents'
export default {
    components: {
        Card,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
    },
    data() {
        return {
            form: {
                email: localStorage.getItem('verdaSupportRemember') || '',
                password: '',
                rememberMe: !!localStorage.getItem('verdaSupportRemember')
            },
            modelValidations: {
                email: {
                    required: true
                },
                password: {
                    required: true,
                    min: MIN_PASSWORD_LENGTH
                }
            },
            loading: false,
            error: false
        }
    },
    beforeDestroy() {
        this.closeMenu()
    },
    methods: {
        getError,
        toggleRememberMe() {
            if (this.form.rememberMe) {
                localStorage.setItem('verdaSupportRemember', this.form.email)
            } else {
                localStorage.removeItem('verdaSupportRemember')
            }
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        async submitLogin() {
            const isValid = await this.$validator.validateAll()
            if (isValid) {
                this.toggleRememberMe()
                const values = {
                    email: this.form.email,
                    password: this.form.password,
                    rememberMe: this.form.rememberMe
                }
                this.loading = true
                this.error = false
                try {
                    await this.$store.dispatch('auth/LOGIN', values)
                } catch (err) {
                    this.error = ((code) => {
                        switch (code) {
                            case 'auth/invalid-email':
                                return 'Invalid email'
                            case 'auth/user-not-found':
                                return 'An account with that email does not exist'
                            case 'auth/wrong-password':
                                return 'Incorrect password'
                            case 'auth/user-disabled':
                                return 'This account has been disabled'
                            case 'auth/unauthorized':
                                return 'This account is unauthorized'
                            default:
                                return 'Invalid login'
                        }
                    })(err.code)
                } finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
i {
    vertical-align: middle;
}
.login-page .card-login .input-group:last-child {
    margin-bottom: 10px;
}
.full-page > .content {
    padding-top: 4rem;
    margin-bottom: 6rem;
}
</style>
